









import { Component, Vue } from 'vue-property-decorator';
import ContentsModlue from '@/store/modules/contents';
import { Fully } from '@/types/fully';
declare let fully: Fully;

@Component
export default class Contents extends Vue {
  // メディアのURLを取得
  private url = ContentsModlue.url;

  // MIME Type が動画かどうか
  private isVideo = ContentsModlue.isVideo;

  // 音声ありかなしか（ChromeやSafariなどで自動再生されないため、）
  private isMuted = true;

  // ストアアクションの購読解除関数
  private unsubscribe?: Function;

  $refs!: {
    video: InstanceType<typeof HTMLVideoElement>;
  };

  activated() {
    this.changeIndex();

    // モジュール監視
    this.unsubscribe = this.$store.subscribe(mutation => {
      if (mutation.type === 'contents/setIndex') {
        this.changeIndex();
      }
    });

    // ChromeやSafariなどで自動再生されないため基本はfalseになるが、
    // Fully Kiosk ブラウザの場合は音声を有効にする
    try {
      if (fully !== undefined) {
        this.isMuted = false;
      }
    } catch (e) {
      //
    }
  }

  deactivated() {
    ContentsModlue.stop();
    this.unsubscribe && this.unsubscribe();
  }

  /**
   * コンテンツのインデックスが更新されたときにURLを適応して再生開始
   */
  private changeIndex() {
    this.url = ContentsModlue.url;
    this.isVideo = ContentsModlue.isVideo;
    this.$forceUpdate();
    this.$nextTick(() => {
      ContentsModlue.SET_VIDEO(this.$refs.video);
      ContentsModlue.play();
    });
  }

  /**
   * 動画再生完了したら次のコンテンツに進む
   */
  private endedVideo() {
    ContentsModlue.next();
  }
}
